'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dDashboard$002dView$0024$0024anon$002428 from "./presto.-Dashboard-View$$anon$28.js";
import * as $j_presto$002etypes$0024$002dCredential$002dKind$0024 from "./presto.types$-Credential-Kind$.js";
import * as $j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount$0024 from "./presto.types$-Dashboard-Credential-Count$.js";
var $p;
/** @constructor */
function $c_Lpresto_DashboardView$$anon$27() {
  this.aMA = null;
  this.aMs = null;
  this.aMt = false;
  this.aMB = null;
  this.aMC = false;
  this.aMF = null;
  this.aMy = null;
  this.aMz = false;
  this.aMu = null;
  this.aMv = false;
  this.aMw = null;
  this.aMx = false;
  this.aMD = false;
  this.aME = false;
  this.aMA = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.aMF = "DashboardCredentialCount";
}
export { $c_Lpresto_DashboardView$$anon$27 as $c_Lpresto_DashboardView$$anon$27 };
$p = $c_Lpresto_DashboardView$$anon$27.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_DashboardView$$anon$27;
/** @constructor */
function $h_Lpresto_DashboardView$$anon$27() {
}
export { $h_Lpresto_DashboardView$$anon$27 as $h_Lpresto_DashboardView$$anon$27 };
$h_Lpresto_DashboardView$$anon$27.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.aMA;
});
$p.M = (function() {
  if ((!this.aMt)) {
    this.aMs = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.aMt = true;
  }
  return this.aMs;
});
$p.O = (function() {
  if ((!this.aMC)) {
    this.aMB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.aMC = true;
  }
  return this.aMB;
});
$p.E = (function() {
  return this.aMF;
});
$p.t = (function() {
  if ((!this.aMz)) {
    this.aMy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("used", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("registered", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aMz = true;
  }
  return this.aMy;
});
$p.N = (function() {
  if ((!this.aMv)) {
    this.aMu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dKind$0024.$m_Lpresto_types$CredentialKind$().cA(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bB, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aMv = true;
  }
  return this.aMu;
});
$p.Q = (function() {
  if ((!this.aMx)) {
    this.aMw = new $j_presto$002e$002dDashboard$002dView$0024$0024anon$002428.$c_Lpresto_DashboardView$$anon$28();
    this.aMx = true;
  }
  return this.aMw;
});
$p.v = (function() {
  if ((!this.aME)) {
    this.aMD = false;
    this.aME = true;
  }
  return this.aMD;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee150) => ((p) => \u03b4scrutinee150.cFP(p)))($j_presto$002etypes$0024$002dDashboard$002dCredential$002dCount$0024.$m_Lpresto_types$DashboardCredentialCount$())));
});
var $d_Lpresto_DashboardView$$anon$27 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_DashboardView$$anon$27, "presto.DashboardView$$anon$27", ({
  Hp: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_DashboardView$$anon$27 as $d_Lpresto_DashboardView$$anon$27 };
//# sourceMappingURL=presto.-Dashboard-View$$anon$27.js.map
